/* =========================================================================
   Arch image row — mobile pagination.

   The carousel itself is pure CSS scroll-snap and works with JS disabled; this
   only keeps the dots in step with the scroll position and lets a dot scroll the
   track. If this file never loads, you lose the dots, not the carousel.

   Vanilla + plain `defer` on purpose: global-arch.js is jQuery-driven and jQuery
   is not loaded in the theme editor, so anything behind it is dead in the
   customiser. This re-scans on shopify:section:load so it survives editor
   re-renders too.
   ========================================================================= */
(function () {
  function init(root) {
    if (root.dataset.airInit === '1') return;

    var track = root.querySelector('[data-air-track]');
    var dotsWrap = root.querySelector('[data-air-dots]');
    if (!track || !dotsWrap) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-air-slide]'));
    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-air-dot]'));
    if (slides.length < 2 || !dots.length) return;

    root.dataset.airInit = '1';

    function setActive(i) {
      for (var d = 0; d < dots.length; d++) {
        var on = d === i;
        dots[d].setAttribute('aria-current', on ? 'true' : 'false');
        // Roving tabindex: the group is one tab stop, not one per dot.
        dots[d].setAttribute('tabindex', on ? '0' : '-1');
      }
    }

    // Active slide is whichever leading edge sits closest to the track's left
    // edge — derived from real scroll position rather than counted ticks, so it
    // stays correct after a fling, a resize or a snap-back.
    function compute() {
      var tr = track.getBoundingClientRect();
      var best = 0, bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slides[i].getBoundingClientRect().left - tr.left);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      setActive(best);
    }

    var raf = false;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = true;
      requestAnimationFrame(function () { raf = false; compute(); });
    }, { passive: true });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var s = slides[i];
        if (!s) return;
        // Scroll the TRACK only. scrollIntoView would also scroll the window
        // vertically and yank the page to the carousel.
        track.scrollTo({
          left: track.scrollLeft + (s.getBoundingClientRect().left - track.getBoundingClientRect().left),
          behavior: 'smooth'
        });
      });

      dot.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = dots[(i + 1) % dots.length];
        else if (e.key === 'ArrowLeft') next = dots[(i - 1 + dots.length) % dots.length];
        if (next) { e.preventDefault(); next.focus(); next.click(); }
      });
    });

    window.addEventListener('resize', compute, { passive: true });
    compute();
  }

  function scan(scope) {
    var rows = (scope || document).querySelectorAll('[data-arch-image-row]');
    for (var i = 0; i < rows.length; i++) init(rows[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
